import { SystemStyleObject } from '@chakra-ui/styled-system';
import { SwitchProps } from '@chakra-ui/switch';

const defaultProps: SwitchProps = {};

const baseStyleTrack = (): SystemStyleObject => {
  return {
    borderRadius: 'full',
    p: '2px',
    paddingInline: '6px',
    height: '1.2rem',
    alignItems: 'center',
    transitionProperty: 'common',
    transitionDuration: 'fast',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'brand.700',
    bg: 'brand.gray100',
    _focus: {
      boxShadow: 'none',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    _checked: {
      bg: 'brand.magenta300',
    },
  };
};

const baseStyleThumb: SystemStyleObject = {
  bg: 'white',
  transitionProperty: 'transform, background',
  borderRadius: 'inherit',
  height: '1.2rem',
  width: '1.2rem',
  boxShadow: '0px 3px 6px #cfcfcf',
  marginLeft: '-3px',
  _checked: {
    bg: 'white',
    marginLeft: '0px',
  },
  _hover: {
    filter: 'brightness (0.9)',
  },
};
const baseStyleContainer: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
};

const baseStyle = () => ({
  track: baseStyleTrack(),
  thumb: baseStyleThumb,
  container: baseStyleContainer,
});

export const Switch = {
  baseStyle,
  defaultProps,
};
